import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  public copyright: string = `Copyright © ${new Date().getFullYear()} PAM Lab at UWF. All rights reserved.`;
  public env = environment;

  constructor() {}

  ngOnInit(): void {}
}
